/** Shared field checks for customer, staff and admin forms. */

export function digitsOnly(value) {
  return String(value || "").replace(/\D/g, "");
}

export function indianMobile10(value) {
  const d = digitsOnly(value);
  if (d.length === 12 && d.startsWith("91")) return d.slice(-10);
  if (d.length === 11 && d.startsWith("0")) return d.slice(-10);
  return d.slice(-10);
}

export function isValidIndianMobile(value) {
  const d = indianMobile10(value);
  return /^[6-9]\d{9}$/.test(d);
}

export function isValidEmail(value) {
  const e = String(value || "").trim().toLowerCase();
  return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(e);
}

export function isValidPersonName(value) {
  const n = String(value || "").trim();
  if (n.length < 2 || n.length > 80) return false;
  return /^[A-Za-z][A-Za-z .'-]*$/.test(n);
}

export function isValidPassword(value, min = 8) {
  return String(value || "").length >= min;
}

export function generatePassword(length = 10) {
  const chars = "ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnpqrstuvwxyz23456789";
  let out = "";
  const cryptoObj = typeof window !== "undefined" ? window.crypto : null;
  for (let i = 0; i < length; i += 1) {
    if (cryptoObj?.getRandomValues) {
      const buf = new Uint32Array(1);
      cryptoObj.getRandomValues(buf);
      out += chars[buf[0] % chars.length];
    } else {
      out += chars[Math.floor(Math.random() * chars.length)];
    }
  }
  return out;
}

export function fieldError({ name, phone, email, password, minPassword = 8 } = {}) {
  if (name !== undefined && !isValidPersonName(name)) {
    return "Enter a valid full name (letters only, min 2 characters).";
  }
  if (phone !== undefined && !isValidIndianMobile(phone)) {
    return "Enter a valid 10-digit Indian mobile number starting with 6–9.";
  }
  if (email !== undefined && !isValidEmail(email)) {
    return "Enter a valid email address.";
  }
  if (password !== undefined && !isValidPassword(password, minPassword)) {
    return `Password must be at least ${minPassword} characters.`;
  }
  return "";
}
